/**
 * Phone checks for the job apply form (#4933).
 *
 * Malaysian candidates often type their number the way it is written locally, and
 * two production applications in one week were saved as numbers WhatsApp rejects
 * (Twilio 21211): `60194638952` with +60 already selected (country code typed
 * twice), and `21084721` (the `11` of `+6011 21084721` left out). `isValidE164`
 * passes both, so +60 gets its own rule. Other country codes keep the E.164 check.
 */

const MALAYSIA = "+60";

/** A Malaysian mobile without the country code or trunk 0: `1` then 8 or 9 digits. */
const MY_MOBILE = /^1\d{8,9}$/;

export const MY_MOBILE_ERROR = "Enter your full mobile number, e.g. 11 2108 4721 or 19 463 8952";

/**
 * The national number to submit for this country code, from what the candidate
 * typed. Digits only. For +60: one leading `0` is dropped (`0194638952`), and a
 * repeated `60` is dropped when what follows is a mobile number (`60194638952`).
 * Other country codes: the digits as typed.
 */
export function localPhoneNumber(countryCode: string, typed: string): string {
    const digits = (typed || "").replace(/\D/g, "");
    if (countryCode !== MALAYSIA) return digits;
    if (digits.startsWith("60") && MY_MOBILE.test(digits.slice(2))) return digits.slice(2);
    if (digits.startsWith("0")) return digits.slice(1);
    return digits;
}

/** True when the number (as returned by `localPhoneNumber`) can be submitted. */
export function isValidLocalPhone(countryCode: string, localNumber: string): boolean {
    if (countryCode !== MALAYSIA) return localNumber.length > 0;
    return MY_MOBILE.test(localNumber);
}
